import { useEffectOnce } from '@chilecompra/react-kit'

/**
 * The UniquePassAuthLogout's container.
 */
const UniquePassAuthLogout = () => {
  useEffectOnce(() => {
    window.close()
  })

  return null
}

export default UniquePassAuthLogout
